import * as React from 'react';
import { FunctionComponent } from 'react';

import { MotorFullPageProps } from 'scenes/motor/types';
import { getAdditionalDrivers } from 'scenes/motor/selectors';
import {
  AdditionalDriversList,
  AdditionalDriversQuestion,
} from './AdditionalDrivers';

export const AddDriverStep: FunctionComponent<MotorFullPageProps> = ({
  funnelState,
  referenceData,
  onEditDriver,
  onRemoveDriver,
  onNext,
}) => {
  const additionalDrivers = getAdditionalDrivers(funnelState);

  return additionalDrivers.length > 0 ? (
    <AdditionalDriversList
      funnelState={funnelState}
      referenceData={referenceData}
      additionalDrivers={additionalDrivers}
      onEditDriver={onEditDriver}
      onRemoveDriver={onRemoveDriver}
      onNext={onNext}
    />
  ) : (
    <AdditionalDriversQuestion
      funnelState={funnelState}
      referenceData={referenceData}
      onNext={onNext}
    />
  );
};

export default AddDriverStep;
